import React, { useCallback, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ADMIN_MENU } from "../../common/constants";
import { useGetNaviInfo } from "../../interfaces/common";
import { CommonMainWrap, CommonModalWrap, CommonSubBox } from "../../styles/common";
import { useGetProjectCodeList, useGetProjectPointInfo, useGetProjects, useGetTargetProjectByPno, useSetProject } from "../../interfaces/project";
import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useGetClients } from "../../interfaces/clients";
import ProjectStatusLabel from "../common/ProjectStatusLabel2";
import { styled } from "styled-components";
import SurveyList from "./SurveyList";
import CommonTab from "../common/CommonTab";
import PointList from "./PointList";
import { DatePicker, DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import SurveyTimeSetList from "./SurveyTimeSetList";
import { useGetSurveyCodeList, useSetProjectSurvey } from "../../interfaces/survey";
import CommonModalBar from "../common/CommonModalBar";
import theme from "../../styles/theme";
import { secCal } from "../../common/util";
import SurveyCars from "./SurveyCars";
import Cars from "../cars_class/Cars";

const ProjectSelectLine = styled.div`
    margin: 0.5rem 0;
    display: grid;
    grid-template-columns: 4rem auto;
    align-items: center;
    gap: 0.5rem;
`
const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
`;

const MainBody = styled.div`
    width: 100%; 
    height: 100%;
    min-height: 100%;
    max-height: 100%;
    flex-grow: 1; 
    border: 1px solid ${theme.color.black[40]};
    border-radius: 12px;
    display: grid;
    grid-template-columns: minmax(10rem,15rem) auto;
    align-items: stretch;
    .list {
        width: 100%;
        height: calc(100% - 2rem);
        margin: 1rem 0;
        padding: 0 1rem;
        border-right: 1px solid ${theme.color.black[40]};
        overflow: hidden;
    }
    .detail {
        width: 100%;
        height: calc(100% - 2rem);
        max-height: calc(100% - 2rem);
        margin: 1rem 0;
        padding: 0 1rem;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        overflow: hidden;
    }
`;

const Detail = () => {

    const navigate = useNavigate();
    const param = useParams();

    const [target, setTarget] = useState(undefined);
    const [setComplete, setSetComplete] = useState(false);
    const [targetSurvey, setTargetSurvey] = useState(undefined);

    const [proList, setProList] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);

    const {data: projectList} = useGetProjects();
    const {data: projectInfo, refetch} = useGetTargetProjectByPno(param.pno);

    const {data: surveyCodeList} = useGetSurveyCodeList();

    useEffect(()=>{
        setSetComplete(false);
        refetch();
    },[param])

    useEffect(()=>{
        if(projectInfo && projectInfo.length > 0){
            if(projectInfo[0].pno === param.pno){
                setTarget(projectInfo[0]);
                setTargetSurvey();
                setSetComplete(true);
            }
        }else if(projectInfo && projectInfo.length === 0){
            setSetComplete(true);
        }
    },[projectInfo])

    useEffect(()=>{
        if(projectList){
            setProList(projectList.map((item,index)=>({
                ...item,
                label:item.pnm})
                ));
        }
    },[projectList])

    return (
        <CommonMainWrap style={{display:'flex',flexDirection:'column',overflow:'hidden'}}>
            <ProjectSelectLine>
                <ProjectStatusLabel status={target && target.pro_st} value={(target && target.pro_st) ? target.pro_st_nm:'신규'}/>
                {((setComplete=== true) && proList && proList.length > 0) &&
                    <Autocomplete
                        id="cid"
                        size='small'
                        options={proList}
                        sx={{ width: 300 }}
                        defaultValue={(target && target.pnm) && target.pnm}
                        // renderOption={(props, option) => {
                        //     return <div><ProjectStatusLabel status={option.pro_st} value={option.pro_st}/>{option.pnm}</div>
                        // }}
                        renderInput={(params) => <TextField {...params} label="과업명" />}
                        onChange={(e,v)=>v!==null&&navigate('/project/'+v.pno)}
                    />
                }
            </ProjectSelectLine>
            { target &&
            <MainBody>
                <div className="list">
                    <SurveyList pid={target && target.pid} onClick={setTargetSurvey}/>
                </div>
                {targetSurvey ?
                    <div className="detail">
                        <CommonTab tabList={(targetSurvey.sid && targetSurvey.sid>0) ? ['기본정보','조사시간','지점설정']:['기본정보']} onClick={setTabIndex}/>
                        <div style={{height:'calc(100% - 2rem)',maxHeight:'calc(100% - 2rem)',flexGrow:1,ovreflow:'auto'}}>
                            {tabIndex === 0 && <NewItem pid={target.pid} item={targetSurvey} codeList={surveyCodeList} />}
                            {tabIndex === 1 && <SurveyTimeSetList survey={targetSurvey} />}
                            {tabIndex === 2 && <PointList survey={targetSurvey} />}
                        </div>
                    </div>
                    :
                    <div className="detail"/>
                }
            </MainBody>
            }
            {/* {targetSurvey && 
            <Row style={{width:'100%', minHeight:'100%',flexGrow:1, alignItems:'stretch'}}>
                
                
            </Row>
            } */}
        </CommonMainWrap>
    )
}

const DetailWrap = styled.div`
    box-sizing: border-box;
    height: 100%;
    // min-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: hidden;
    .descItem  {
        padding-top: 1rem;
        flex-grow: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        overflow: auto;
    }
`;

const NewItem = ({pid, item, codeList}) => {

    const queryClient = useQueryClient();
    const initParam = {
                    sid:null,
                    snm:'',
                    tu:60,
                    time_unit:'',
                    ccid:'',
                    ccnm:'',
                    sur_tp:'',
                    sur_tp_nm:'',
                    descr:'',
                }

    const [target, setTarget] = useState(initParam);

    const [surTpList, setSurTpList] = useState([]);
    const [ccnmList, setCcnmList] = useState([]);

    const {mutate} = useSetProjectSurvey();

    useEffect(()=>{
        if(item && item.sid>0){
            setTarget({...item,tu:60});
        }else{
            setTarget(initParam)
        }
    },[item])

    useEffect(()=>{
        if(codeList){
            setSurTpList(codeList.sur_tp.map((item,index)=>({
                ...item,
                label:item.value})
                ));
            setCcnmList(codeList.cars_class.map((item,index)=>({
            ...item,
            label:item.ccnm})
            ));
        }
    },[codeList])

    const handleValueChange = (id,val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleAutoValueChange = (id,val1,id2,val2) => {
        const temp  = {...target,[id]:val1,[id2]:val2}
        setTarget(temp);
    }

    const handleTimeUnitChange = (value) => {

        handleValueChange('time_unit',value*target.tu);
    }

    const handleUpdateClick = useCallback((updateItem) => {
        const temp = {
            mode: updateItem.sid>0 ? 'PUT':'POST',
            ...updateItem,
            pid: pid
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'등록하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDeleteClick = (updateItem) => {
        queryClient.setQueryData(
            [MODAL_QUERY_NM],
            {
                show:true,
                msg:'삭제하시겠습니까?',
                height:'20vh',
                okButton:()=>confirmDelete(updateItem)
            }
        )
    }

    const confirmDelete = useCallback((updateItem) => {
        const temp = {
            mode: 'DELETE',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    return (
        <DetailWrap>
            <div className="descItem">
                <Row>
                <Autocomplete
                        id="sur_tp"
                        size='small'
                        options={surTpList}
                        style={{width:'10rem'}}
                        value={(target && target.sur_tp_nm) && target.sur_tp_nm}
                        renderInput={(params) => <TextField {...params} label='유형'InputLabelProps={{shrink:true}} />}
                        onChange={(e,v)=>(v!==null)&&handleAutoValueChange('sur_tp',v.code,'sur_tp_nm',v.value)}
                    />
                <TextField
                    id='snm'
                    label='조사명'
                    size="small"
                    style={{width:'100%'}} 
                    value={target && target.snm}
                    InputLabelProps={{shrink:true}}
                    onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                />
                </Row>
                <TextField
                    id='descr'
                    label='조사내용'
                    size="small"
                    style={{width:'100%'}} 
                    value={target && target.descr}
                    InputLabelProps={{shrink:true}}
                    onChange={(e)=>handleValueChange(e.target.id, e.target.value)}
                />
                { target &&
                    <Row>
                        <Autocomplete
                                id="ccid"
                                size='small'
                                options={ccnmList}
                                style={{width:'15rem'}}
                                value={(target && target.ccnm) && target.ccnm}
                                renderInput={(params) => <TextField {...params} label='조사차종' InputLabelProps={{shrink:true}}/>}
                                onChange={(e,v)=>(v!==null)&&handleAutoValueChange('ccid',v.ccid,'ccnm',v.ccnm)}
                            />
                            <TextField
                        id='time_unit'
                        label='조사시간'
                        size="small"
                        style={{width:'4rem'}} 
                        value={(target && target.time_unit) && target.time_unit/target.tu}
                        InputLabelProps={{shrink:true}}
                        onChange={(e)=>handleTimeUnitChange(e.target.value)}
                    />
                    <FormControl size="small" style={{width:'5rem'}}>
                        <InputLabel id="tu-label">단위</InputLabel>
                        <Select
                            id='tu'
                            labelId="tu-label"
                            label='단위'
                            InputLabelProps={{shrink:true}}
                            value={target && target.tu}
                            onChange={(e)=>handleValueChange('tu', e.target.value)}
                            >
                            <MenuItem value={60} > 분</MenuItem>
                            <MenuItem value={1}> 초</MenuItem>
                        </Select>
                    </FormControl>
                    </Row>
                }
                {(target && (target.ccid && target.ccnm)) &&
                    <Row style={{border:'1px solid '+theme.color.black[20], borderRadius:'12px',height:'100%'}}>
                        <Cars mode={'VIEW'} ccid={target.ccid} />
                    </Row>
                }
            </div>
            <Row>
                <Button variant='contained' style={{width:'100%'}} onClick={()=>handleUpdateClick(target)}>{(target && target.sid > 0) ?'수정':'등록'}</Button>
                <Button variant='contained' style={{width:'100%'}} onClick={()=>handleDeleteClick(target)}>삭제</Button>
            </Row>
        </DetailWrap>
    )

}

export default Detail;